module.exports = __webpack_public_path__ + "img/product-5.1b1d5538.png";